var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBathBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38902 17.5274C4.55151 17.5274 2.2036 15.3649 1.87325 12.584H19.1277C18.7973 15.3649 16.4494 17.5274 13.611 17.5274H7.38902ZM8.50018 6.51698C8.50018 5.40168 9.39748 4.49434 10.5005 4.49434C11.6034 4.49434 12.4998 5.40168 12.4998 6.51698C12.4998 6.64121 12.4006 6.74151 12.2778 6.74151H8.72223C8.60029 6.74151 8.50018 6.64121 8.50018 6.51698ZM7.38902 0C3.5905 0 0.5 3.12506 0.5 6.96604V11.9104C0.5 14.8808 2.34921 17.4234 4.94465 18.4227V20H6.27786V18.7844C6.64006 18.8451 7.01044 18.8764 7.38902 18.8764H13.611C13.9896 18.8764 14.3609 18.8451 14.7231 18.7844V20H16.0554V18.4227C18.6517 17.4234 20.5 14.8808 20.5 11.9104V11.2359H1.83321V6.96604C1.83321 3.86859 4.32582 1.34812 7.38902 1.34812C8.53567 1.34812 9.50032 2.15147 9.76241 3.23088C8.27813 3.57044 7.16697 4.91488 7.16697 6.51698C7.16697 7.38474 7.86497 8.08963 8.72223 8.08963H12.2778C13.1359 8.08963 13.8339 7.38474 13.8339 6.51698C13.8339 4.87163 12.6618 3.49867 11.1175 3.20512C10.8253 1.39045 9.26462 0 7.38902 0Z",
    fill: "#004087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBathBlue);
export default __webpack_public_path__ + "static/media/iconBathBlue.04f9d0c92aeec7c1634767ebd0e87a49.svg";
export { ForwardRef as ReactComponent };